// extracted by mini-css-extract-plugin
export default {"wrapper":"TabButton_wrapper__jzPuV","active":"TabButton_active__iZvlk","disable":"TabButton_disable__XysR4"};